import React from 'react';
import { Link } from 'react-router';
import device from '../../../../services/mini/device';

function BillingTileLink({ title, to, onClick, className }) {
    const isDesktop = device.isDesktop();
    const classes = !isDesktop ? 'action-btn' : '';
    return <div className={`billing-tile-link ${className}`}>
        {onClick ?
            <a className={classes} onClick={onClick}>{title}</a> :
            <Link className={classes} to={to}>{title}</Link>
        }
    </div>;
}

export default BillingTileLink;
